module.exports = __webpack_public_path__ + "static/media/Enter_Arrow_Right.4559cfe2.svg";